/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_BodyInputs */

const en_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I work with founders and product teams to ship and scale real software. From MVPs to full rewrites, I focus on production-ready systems that don't break in the wild.`)
};

const ar_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعمل مع المؤسسين وفرق المنتجات لإطلاق وتوسيع برمجيات حقيقية. من النماذج الأولية إلى إعادة البناء الكاملة، أركز على أنظمة جاهزة للإنتاج لا تتعطل بعد الإطلاق.`)
};

const bn_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিষ্ঠাতা ও প্রোডাক্ট টিমের সঙ্গে কাজ করে বাস্তব সফটওয়্যার তৈরি ও স্কেল করি। MVP থেকে সম্পূর্ণ রিরাইট, প্রোডাকশনে নির্ভরযোগ্যভাবে চলে, এমন সিস্টেম বানাই।`)
};

const de_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich arbeite mit Gründern und Produktteams an der Entwicklung und Skalierung echter Software. Von MVPs bis zu kompletten Neuentwicklungen baue ich Systeme, die produktionsreif und zuverlässig sind.`)
};

const es_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo con fundadores y equipos de producto para lanzar y escalar software real. Desde MVPs hasta reconstrucciones completas, creo sistemas listos para producción.`)
};

const fr_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J’accompagne les fondateurs et les équipes produit pour lancer et faire évoluer des logiciels fiables. Des MVP aux refontes complètes, je construis des systèmes prêts pour la production.`)
};

const pt_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho com fundadores e equipes de produto para lançar e escalar software real. De MVPs a reescritas completas, crio sistemas prontos para produção.`)
};

const zh_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我与创始人和产品团队合作交付和扩展真正的软件。从 MVP 到完全重写，我专注于上线后不出问题的生产级系统。`)
};

const tr_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek yazılımı çıkarıp ölçeklemek için kurucular ve ürün ekipleriyle çalışırım. MVP'lerden baştan yazımlara, sahada bozulmayan, üretime hazır sistemlere odaklanırım.`)
};

const ru_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я работаю с фаундерами и продуктовыми командами над выпуском и масштабированием настоящего софта. От MVP до полного переписывания, фокус на прод-готовых системах, которые не ломаются в бою.`)
};

const pl_cta_body = /** @type {(inputs: Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Współpracuję z założycielami i zespołami produktowymi, żeby dowozić i skalować prawdziwe oprogramowanie. Od MVP po pełne przepisanie, stawiam na systemy gotowe na produkcję, które nie sypią się po wdrożeniu.`)
};

/**
* | output |
* | --- |
* | "I work with founders and product teams to ship and scale real software. From MVPs to full rewrites, I focus on production-ready systems that don't break in t..." |
*
* @param {Cta_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_body = /** @type {((inputs?: Cta_BodyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_BodyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_body(inputs)
	if (locale === "bn") return bn_cta_body(inputs)
	if (locale === "de") return de_cta_body(inputs)
	if (locale === "es") return es_cta_body(inputs)
	if (locale === "fr") return fr_cta_body(inputs)
	if (locale === "pt") return pt_cta_body(inputs)
	if (locale === "zh") return zh_cta_body(inputs)
	if (locale === "tr") return tr_cta_body(inputs)
	if (locale === "ru") return ru_cta_body(inputs)
	if (locale === "pl") return pl_cta_body(inputs)
	return en_cta_body(inputs)
});